/** Sets iframe `title` after Datatrans Secure Fields injects cross-origin iframes. */
export const setSecureFieldIframeTitle = (containerId: string, title: string) => {
  if (!title) return;
  document.getElementById(containerId)?.querySelector('iframe')?.setAttribute('title', title);
};
